import Client from '../../PreviousAppointments/Client/Client'
import { IPreviousAppointment } from '../../PreviousAppointments/IPreviousAppointment'
import { AppDispatch } from '../../store/store'

export const FETCHING_PAYMENT_STATUS = 'FETCHING_PAYMENT_STATUS'
export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS'
export const PAYMENT_FAILED = 'PAYMENT_FAILED'
export const PAYMENT_URL_INVALID = 'PAYMENT_URL_INVALID'
export const PAYMENT_STATUS_FETCHED = 'PAYMENT_STATUS_FETCHED'

function fetchingPaymentStatus() {
  return {
    type: FETCHING_PAYMENT_STATUS,
  }
}

function paymentSuccess(appointment: IPreviousAppointment) {
  return {
    type: PAYMENT_SUCCESS,
    appointment,
  }
}

function paymentFailed() {
  return {
    type: PAYMENT_FAILED,
  }
}

function paymentUrlInvalid() {
  return {
    type: PAYMENT_URL_INVALID,
  }
}

function paymentStatusFetched() {
  return {
    type: PAYMENT_STATUS_FETCHED,
  }
}

export function isPaymentComplete(
  establishmentId: string,
  email: string,
  token: string,
  appointmentId: string
) {
  return (dispatch: AppDispatch) => {
    dispatch(fetchingPaymentStatus())

    Client.getPreviousAppointments(establishmentId, email, token)
      .then((previousAppointments) => {
        if (previousAppointments.appointments.length === 0) {
          dispatch(paymentUrlInvalid())
          return null
        }
        const foundAppointment = previousAppointments.appointments.find(
          (appointment) => appointment.id === parseInt(appointmentId, 10)
        )

        if (!foundAppointment?.deposit) {
          // Only appointments with a deposit have a payment status
          dispatch(paymentUrlInvalid())
          return null
        }

        switch (foundAppointment.deposit.status) {
          case 'paid':
            dispatch(paymentSuccess(foundAppointment))
            break
          case 'failed':
          case 'expired':
          case 'canceled':
            dispatch(paymentFailed())
            break
          default:
            // For 'pending', 'authorized', 'open' - reset fetching to allow polling to continue
            dispatch(paymentStatusFetched())
            break
        }

        return null
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error('error checking payment status', e)
        // Reset fetching to allow polling to retry
        dispatch(paymentStatusFetched())
      })
  }
}
